import { render, staticRenderFns } from "./Thumbnail.vue?vue&type=template&id=4ec1c4aa&scoped=true"
import script from "./Thumbnail.vue?vue&type=script&lang=js"
export * from "./Thumbnail.vue?vue&type=script&lang=js"
import style0 from "./Thumbnail.vue?vue&type=style&index=0&id=4ec1c4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec1c4aa",
  null
  
)

export default component.exports